/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AllergensAllergen from './AllergensAllergen';

/**
 * The AllergensBody model module.
 * @module model/AllergensBody
 * @version v0.3
 */
export default class AllergensBody {
  /**
   * Constructs a new <code>AllergensBody</code>.
   * @alias module:model/AllergensBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AllergensBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AllergensBody} obj Optional instance to populate.
   * @return {module:model/AllergensBody} The populated <code>AllergensBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AllergensBody();
      if (data.hasOwnProperty('allergen'))
        obj.allergen = AllergensAllergen.constructFromObject(data['allergen']);
    }
    return obj;
  }
}

/**
 * @member {module:model/AllergensAllergen} allergen
 */
AllergensBody.prototype.allergen = undefined;

